/**
 * Adult Signature Logic
 * Adds Variant ID 62763497390449 based on checkbox state and cart weight.
 * Weight Logic: 1 qty per 50lbs (50lbs = 1, 51-100lbs = 2, etc.)
 */
window.manageSignatureFee = function(cart, forceState, refreshCallback) {

  var signatureId = 62763497390449;
  var hazmatVariantIds = [
    62787679289713,
    62787679945073,
    62787680305521,
    62787680338289,
    62787680436593
  ];
  var updates = {};
  var hasChange = false;
  var currentQty = 0;
  var itemFound = false;
  var totalGrams = 0;

  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];

    if (item.variant_id === signatureId) {
      currentQty = item.quantity;
      itemFound = true;
    } else if (hazmatVariantIds.indexOf(item.variant_id) === -1) {
      totalGrams += (item.grams * item.quantity);
    }
  }

  var weightInLbs = totalGrams / 453.59237;

  console.log('[SIGNATURE FEE] Cart weight', { totalGrams: totalGrams, weightInLbs: weightInLbs.toFixed(2), currentSigQty: currentQty, sigAlreadyInCart: itemFound });

  var shouldBeInCart = (forceState !== null && forceState !== undefined) ? forceState : itemFound;

  var desiredQty = 0;

  if (shouldBeInCart && weightInLbs > 0) {
    desiredQty = Math.ceil(weightInLbs / 50);
  }

  console.log('[SIGNATURE FEE] Calculation result', { shouldBeInCart: shouldBeInCart, desiredQty: desiredQty, currentQty: currentQty, needsUpdate: currentQty !== desiredQty });

  if (currentQty !== desiredQty) {
    updates[signatureId] = desiredQty;
    hasChange = true;
  }

  if (hasChange) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(response) { return response.json(); })
    .then(function(updatedCart) {
      console.log('[SIGNATURE FEE] Update successful, cart now has sig qty:', updatedCart.items.filter(function(it) { return it.variant_id === signatureId; }).reduce(function(sum, it) { return sum + it.quantity; }, 0));
      if (typeof refreshCallback === 'function') {
        refreshCallback(updatedCart);
      }
    })
    .catch(function(e) {
      console.error('[SIGNATURE FEE] Update Failed:', e);
    });
    return true;
  }

  return false;
};

// Adult Signature hook into v2 cart events
(function() {
  let sigUpdateInProgress = false;

  // Sync checkbox with cart state after cart updates
  document.addEventListener('cart:updated', function(event) {
    if (sigUpdateInProgress) {
      console.log('[SIGNATURE FEE] sigUpdateInProgress, skipping cart:updated handler');
      return;
    }

    if (!window.manageSignatureFee) return;

    var cart = event.detail.cart;
    if (!cart || !cart.items) return;

    var sigId = 62763497390449;
    var hasSig = cart.items.some(function(item) { return item.variant_id === sigId; });

    console.log('[SIGNATURE FEE] cart:updated event', { hasSig: hasSig, sigUpdateInProgress: sigUpdateInProgress });

    var sigUpdated = window.manageSignatureFee(cart, null, function(updatedCart) {
      console.log('[SIGNATURE FEE] cart:updated fee check complete');
      var sigInCart = updatedCart.items.some(function(item) { return item.variant_id === sigId; });
      document.querySelectorAll('.adult-signature-input').forEach(function(el) {
        el.checked = sigInCart;
      });

      var refreshEvent = new CustomEvent('cart:refresh', {
        detail: { open: true }
      });
      document.dispatchEvent(refreshEvent);

      setTimeout(function() {
        sigUpdateInProgress = false;
      }, 500);
    });

    if (sigUpdated) {
      sigUpdateInProgress = true;
    } else {
      document.querySelectorAll('.adult-signature-input').forEach(function(el) {
        el.checked = hasSig;
      });
    }
  });

  // Adult Signature Checkbox Listener
  document.addEventListener('change', function(e) {
    if (e.target.matches('.adult-signature-input')) {
      var isChecked = e.target.checked;
      console.log('[SIGNATURE FEE] Checkbox changed', { isChecked: isChecked });

      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          sigUpdateInProgress = true;
          var sigUpdated = window.manageSignatureFee(cart, isChecked, function(updatedCart) {
            console.log('[SIGNATURE FEE] Refresh callback after checkbox change');
            var refreshEvent = new CustomEvent('cart:refresh', {
              detail: { open: true }
            });
            document.dispatchEvent(refreshEvent);
            sigUpdateInProgress = false;
          });

          if (!sigUpdated) {
            sigUpdateInProgress = false;
          }
        });
    }
  });

  // Fix: Force Fee Calculation on Page Load
  function runSignatureFeeCheck() {
    console.log('[SIGNATURE FEE] Running page-load fee check');
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        console.log('[SIGNATURE FEE] Page load cart data', { itemCount: cart.items.length, items: cart.items.map(function(it) { return { id: it.variant_id, qty: it.quantity, title: it.product_title }; }) });

        var sigId = 62763497390449;
        var hazmatVariantIds = [62787679289713, 62787679945073, 62787680305521, 62787680338289, 62787680436593];
        var sigWeightGrams = 0;
        var hazmatWeightGrams = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.variant_id !== sigId && hazmatVariantIds.indexOf(item.variant_id) === -1) {
            sigWeightGrams += item.grams * item.quantity;
          }
          if (item.product_type === 'Powder' || item.product_type === 'Primers') {
            hazmatWeightGrams += item.grams * item.quantity;
          }
        }
        console.log('[PAGE LOAD WEIGHT]', {
          sigWeightLbs: (sigWeightGrams / 453.59237).toFixed(2),
          sigWeightGrams: sigWeightGrams,
          hazmatWeightLbs: (hazmatWeightGrams / 453.59237).toFixed(2),
          hazmatWeightGrams: hazmatWeightGrams
        });

        var runSigCheck = function(currentCart) {
          if (window.manageSignatureFee) {
            window.manageSignatureFee(currentCart, null, function(newCart) {
              console.log('[SIGNATURE FEE] Page load refresh triggered');
              var refreshEvent = new CustomEvent('cart:refresh', {
                detail: { open: true }
              });
              document.dispatchEvent(refreshEvent);
            });
          }
        };

        if (window.manageHazmatFee) {
          console.log('[SIGNATURE FEE] Running hazmat fee check first (chained)');
          var hazmatUpdated = window.manageHazmatFee(cart, function(newCart) {
            console.log('[SIGNATURE FEE] Hazmat fee caused reload, hazmat updated cart');
            window.location.reload();
          });

          if (!hazmatUpdated) {
            runSigCheck(cart);
          } else {
            console.log('[SIGNATURE FEE] Hazmat fee was updated, signature check will run after reload');
          }
        } else {
          runSigCheck(cart);
        }
      })
      .catch(function(error) {
        console.error('[SIGNATURE FEE] Page load check failed:', error);
      });
  }

  if (!window.signatureFeeInitialized) {
    window.signatureFeeInitialized = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runSignatureFeeCheck);
    } else {
      runSignatureFeeCheck();
    }
  }
})();
